import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import UnitDisplay from '../components/entity/UnitDisplay'
import InventoryDisplay from '../components/entity/InventoryDisplay'
import DefaultFrame from '../components/frame/DefaultFrame'
import BackLink from '../components/ui/navigation/BackLink'
import { addToEquipment, removeFromEquipment } from '../redux/actions/game/equipment.actions'
import getEquipment from '../redux/selectors/getEquipment'
import getInventory from '../redux/selectors/getInventory'

const getCurrentUnit = (unitID, roster) => roster[unitID]

const UnitPage = (props) => {
    const {
        baseUnit, equipment, inventory, equipItemWithTarget, unequipItem,
    } = props
    const { ID: unitID } = baseUnit

    function dispatchWithTarget(fn, items) {
        return fn(items, unitID)
    }

    const equipItem = items => dispatchWithTarget(equipItemWithTarget, items)

    return (
        <DefaultFrame>
            <div className="scene--base scene__unit">
                <div className="scene--title">
                    <BackLink>
                        <button className="backLink--title" type="button">Back</button>
                    </BackLink>
                    <h1>Unit Page</h1>
                </div>
                <div className="unit__monitor">
                    <UnitDisplay
                        baseUnit={baseUnit}
                        equipment={equipment}
                        showEquipment
                        showStats
                        handleEquip={{ enabled: false }}
                        handleUnequip={{ enabled: true, handler: unequipItem }}
                    />
                    <InventoryDisplay
                        inventory={inventory}
                        handleEquip={{ enabled: true, handler: equipItem }}
                        handleUnequip={{ enabled: false }}
                    />
                </div>
                <BackLink>
                    <button className="backLink--base" type="button">Back to previous screen</button>
                </BackLink>
            </div>
        </DefaultFrame>
    )
}

UnitPage.propTypes = {
    baseUnit: PropTypes.object.isRequired,
    equipment: PropTypes.array.isRequired,
    inventory: PropTypes.array.isRequired,
    equipItemWithTarget: PropTypes.func.isRequired,
    unequipItem: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
    baseUnit: getCurrentUnit(state.unitID, state.roster),
    equipment: getEquipment(state),
    inventory: getInventory(state),
})

const mapDispatchToProps = dispatch => ({
    equipItemWithTarget: (items, unitID) => dispatch(addToEquipment(items, unitID)),
    unequipItem: items => dispatch(removeFromEquipment(items)),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(UnitPage)
